<template>
  <div class="threejsContainer">
      <div class="containerTitle">1-20.框架：多场景框架
        <button id="infoButton" @click="switchControl">切换控制器</button>
        <button id="swithParamScene" @click="swithParamScene">切换参数场景</button>
      </div>
      <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import {RendererManager} from '@/core/RendererManager.js';
import {GlobalManager} from '@/core/GlobalManager.js';
import EventBus from '@/core//EventBus.js';
import Map3DScene from './components/Map3DScene.js';
import ParamSelectScene from './components/ParamSelectScene.js';

export default {
  data() {
    return {
      renderer: null,
      map3DScene: null,
      animationId: null,
      paramSelectScene: null
    };
  },
  mounted() {
    //初始化环境
    this.initEnv();
    this.initLayer();
    this.initEvent();
    this.animate();
  },
  methods: {
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      this.renderer.autoClear = false;
      this.map3DScene.animate();
      this.paramSelectScene.animate();
    },
    initEnv(){
      // 初始化渲染器
      this.renderer = RendererManager.genRenderer(); 
      this.$refs.container.appendChild(this.renderer.domElement);

      // 将container存入全局容器中
      GlobalManager.set("gContainer",this.$refs.container);

      // 将window存入全局容器中
      GlobalManager.set("window",window);
      
      // 将渲染器存入全局容器中
      GlobalManager.set("renderer",this.renderer);
    },
    initLayer(){
      // 实例化“场景层”
      this.map3DScene = new Map3DScene();
      this.paramSelectScene = new ParamSelectScene();
    },
    initEvent(){
        window.addEventListener('resize', () => {
            //调用事件总线方法
            EventBus.emit('resize');
        });
    },
    swithParamScene(){
      this.paramSelectScene.enabled = !this.paramSelectScene.enabled 
    },
    switchControl(){
      this.map3DScene.changeCameraContoller();
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.renderer.domElement.remove();
  }
};
</script>

<style>
#infoButton {
pointer-events: auto !important;
}
</style>
